import React, { Component } from 'react';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';
import '../../css/components/Announcement/slider-animation.css';
import '../../css/components/Announcement/announcement.css';
import AxiosInstance from '../AxiosInstance/AxiosInstance';
import { Row, Col, Button } from 'reactstrap';
import Moment from 'react-moment';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'


const image = process.env.PUBLIC_URL + '/assets/img/banner-img-min.png';
const ResponsiveEllipsis = responsiveHOC()(HTMLEllipsis);

class Announcement extends Component {

  handleClick() {
    window.location.hash = "#/annoucement/detailannoucement";
  }

  constructor(props) {
    super(props);

    this.state = {
      content: []
    }
    this.handleClick = this.handleClick.bind();
  }


  GetAnnoucement() {
    AxiosInstance({
      method: "post",
      url: "tbGEN_m_MEssageBoard/usp_tbGEN_m_MessageBoard_BCMSelectByDepartmentIDAndUserID_Ex",
    }).then(response => {
      this.setState({ content: response.data });
    }).catch(error => {
    });
  }

  componentDidMount() {
    this.GetAnnoucement();
  }


  render() {
    return (
      <div>
        <Slider className="slider-wrapper " autoplay={2500} >
          {this.state.content.map((item, index) => (
            <div key={index} className="slider-content ">

              <div className="inner">
                <div className="row">

                  <div className="col-lg-8 announcement-content d-flex align-items-center">
                    <div className="announcement-group">
                      <div className="banner-description">
                      <h3 className="bannerName-col">
                        { /*Height had set for the responsive ellipsis*/}
                    <ResponsiveEllipsis  className="bannerName"
                        unsafeHTML={item.name}
                        maxLine='2'
                        ellipsis='...'
                        basedOn='letters' />
                    </h3>
                      {/*Height had set for the responsive ellipsis*/}
                      <h5 className="">
                        <ResponsiveEllipsis className="bannerMessage"
                        unsafeHTML={item.message}
                        maxLine='2'
                        ellipsis='...'
                        basedOn='letters' />
                        </h5>
                      </div>
                      <div className=" banner-action">
                      <Button color="outline-banner" onClick={this.handleClick}>Read More</Button>
                      <div className="eventDateTime">
                          <div className="bannerIcon mx-2"><i className="icon-calendar icons "></i></div>
                          <Moment format="MMM" parse="YYYY-MM-DD">{item.createdDT}</Moment>
                          <strong className="text-white mx-1">
                          <Moment format="DD" parse="YYYY-MM-DD">{item.createdDT}</Moment>
                        </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="graphic-overlay col-lg-4 d-none d-md-flex d-lg-flex justify-content-end ">
                    <img src={process.env.PUBLIC_URL + "/assets/img/banner-img-min.png"} className="img-banner" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}
export default Announcement;
